import { Controller } from "@hotwired/stimulus"

// Enables the submit button only while the form differs from its saved values.
export default class extends Controller {
  static targets = ["submit"]
  static values = { saveLabel: String, savedLabel: String }

  connect() {
    this.snapshot()
  }

  snapshot() {
    this.savedValues = this.serialize()
    this.update()
  }

  update() {
    this.submitTarget.disabled = this.serialize() === this.savedValues
    this.submitTarget.value = this.submitTarget.disabled ? this.savedLabelValue : this.saveLabelValue
  }

  submitEnd({ detail: { success } }) {
    if (success) this.snapshot()
  }

  // The CSRF token is re-rendered on every page refresh, so it is not part of the form's state.
  serialize() {
    const data = new FormData(this.element)
    data.delete("authenticity_token")
    return new URLSearchParams(data).toString()
  }
}
